<template>
  <section id="settings">
    <div class="container">
      <h1>Settings</h1>
      <p class="lead">Update your profile</p>
      <transition name="fade">
        <p v-if="showSuccess" class="success">Profile updated!</p>
      </transition>
      <form @submit.prevent>
        <div class="form-group">
          <label for="name">Your Name</label>
          <input class="form-control" v-model="name" type="text" :placeholder="userProfile.name" id="name" />
        </div><!-- /.form-group -->
        <div class="form-group">
          <label for="company">Company</label>
          <input class="form-control" v-model="company" type="text" :placeholder="userProfile.company" id="company" />
        </div><!-- /.form-group -->
        <button class="btn btn-primary" @click="updateProfile">Update Profile</button>
      </form>
    </div><!-- /.container -->
  </section>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    data() {
      return {
        name: '',
        company: '',
        showSuccess: false
      }
    },
    computed: {
      ...mapState(['userProfile'])
    },
    methods: {
      updateProfile() {
        this.$store.dispatch('updateProfile', {
          name: this.name !== '' ? this.name : this.userProfile.name,
          company: this.company !== '' ? this.company : this.userProfile.company
        })
        this.name = ''
        this.company = ''
        this.showSuccess = true
        setTimeout(() => { this.showSuccess = false }, 2000)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Settings.vue